import { render, staticRenderFns } from "./CheckpointFormAddress.vue?vue&type=template&id=61cc5132"
import script from "./CheckpointFormAddress.vue?vue&type=script&lang=js"
export * from "./CheckpointFormAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports